import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  position: relative;
  color: ${themeGet('colors.white')};
`

export const ImageHolder = styled(Flex)`
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  height: 144px;
  width: 144px;
  border-radius: 8px;
  border: 1px solid ${themeGet('colors.softPeach')};

  img {
    width: 144px !important;
    object-fit: cover;
    object-position: top;
  }
`
